import { render, staticRenderFns } from "./v-field.vue?vue&type=template&id=f4e1e8ba&lang=pug&"
import script from "./v-field.vue?vue&type=script&lang=js&"
export * from "./v-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports